<template>
  <div class="col-12">
    <div class="row">
      <card-default>
        <div
          slot="title"
          class="card-heading row">
          <div class="col h4">
            {{ edit ? 'Edit layout' : 'New layoyut' }}
          </div>
          <div class="col float-right">
            <auth-button
              :permission="edit ? 'layout-update' : 'layout-create'"
              class="btn btn-primary btn-micro float-right"
              @click="save"
            >
              Save
            </auth-button>
          </div>
        </div>
        <div
          slot="body"
          class="card-text">
          <div class="row">
            <field-input
              v-model="name"
              name="name"
              label="Layout name"
              class="col"
              required
            />
          </div>
          <div
            v-show="activeSite && activeSite.id"
            class="row">
            <div class="col">
              <div class="form-group">
                <div class="input-group">
                  <label class="control-label">
                    For active site only
                    <input
                      v-model="siteSpecific"
                      type="checkbox">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="myPermissions['layout-content-create']"
            class="row"
          >
            <div class="col">
              <field-json v-model="json" />
            </div>
          </div>
        </div>
      </card-default>
    </div>
    <div class="row">
      <card-default v-if="edit">
        <div
          slot="title"
          class="card-heading row">
          <div class="col h4">
            Delete
          </div>
          <div class="col float-right">
            <auth-button
              class="btn btn-danger btn-micro float-right"
              permission="layout-delete"
              @click="confirmRemove"
            >
              Delete
            </auth-button>
          </div>
        </div>
      </card-default>
    </div>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'
import FieldTextarea from '@/components/form/FieldTextarea'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Vue from 'vue'
import FieldJson from '@/components/form/FieldJson'

export default {
  name: 'PagesList',

  components: {
    FieldInput,
    CardDefault,
    FieldTextarea,
    FieldJson
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('layout', [
      'newLayout'
    ]),
    ...mapGetters('permission', [
      'myPermissions'
    ]),
    ...mapGetters({
      activeSite: 'site/active'
    }),
    name: {
      get () {
        return this.newLayout.name
      },
      set (newVal) {
        this.updateNew({
          key: 'name',
          value: newVal
        })
      }
    },
    json: {
      get () {
        return this.newLayout.json
      },
      set (newVal) {
        this.updateNew({
          key: 'json',
          value: newVal
        })
      }
    },
    siteSpecific: {
      get () {
        return !!this.newLayout.site_id
      },
      set (newVal) {
        this.updateNew({
          key: 'site_id',
          value: newVal ? this.activeSite.id : null
        })
      }
    }
  },

  created () {
    if (!this.edit) {
      this.clear()
    }
  },

  methods: {
    ...mapActions('layout', [
      'create',
      'update',
      'remove'
    ]),
    ...mapMutations('layout', {
      updateNew: 'UPDATE_NEW',
      clear: 'CLEAR_NEW'
    }),

    save () {
      if (this.edit) {
        try {
          this.update()
        } catch (e) {
          Vue.toasted.showError(e.toString())
        }
      } else {
        this.create().then(() => {
          this.$router.push('.')
        })
      }
    },

    confirmRemove () {
      if (confirm('Are you sure you want to delete this layout?')) {
        this.remove(this.newLayout.id).then(() => {
          this.$router.push('.')
        })
      }
    }
  }
}
</script>
